<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Create payout record</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-combobox
                :items="campaigns"
                :search-input.sync="search"
                :error-messages="selectedCampaignErrors"
                hide-details="auto"
                item-text="name"
                @input="$v.payout.campaign.$touch()"
                @blur="$v.payout.campaign.$touch()"
                @change="changeCampaign()"
                v-model="payout.campaign"
                label="Campaign Name"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ search }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <v-combobox
                :items="clients"
                :search-input.sync="searchClient"
                hide-details="auto"
                v-model="payout.client"
                item-text="name"
                label="Client"
                dense
                small-chips
                outlined
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        No results matching "
                        <strong>{{ searchClient }}</strong
                        >". Press <kbd>enter</kbd> to create a new one
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-combobox
                :items="influencers"
                item-text="handle"
                hide-details="auto"
                v-model="payout.handle"
                label="Influencers"
                prefix="@"
                dense
                outlined
                @input="$v.payout.handle.$touch()"
                @blur="$v.payout.handle.$touch()"
                @change="changeInfluencer()"
              >
              </v-combobox>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Swift Code"
                hide-details
                v-model="payout.bankSwiftCode"
                placeholder="RABONL2U"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Bank A/C No."
                placeholder="Bank A/C No.(omit dashes)"
                v-model="payout.bankAccountNo"
                :error-messages="bankNoErrors"
                hide-details="auto"
                @input="$v.payout.bankAccountNo.$touch()"
                @blur="$v.payout.bankAccountNo.$touch()"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Payee Name"
                placeholder="Payee Name."
                :error-messages="receivingNameErrors"
                v-model="payout.receivingName"
                hide-details="auto"
                @input="$v.payout.receivingName.$touch()"
                @blur="$v.payout.receivingName.$touch()"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Amount"
                type="number"
                v-model="payout.amount"
                @input="$v.payout.amount.$touch()"
                @blur="$v.payout.amount.$touch()"
                placeholder="300"
                prefix="$"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
              <v-checkbox
                v-model="payout.chkGST"
                hide-details
                label="Include GST 9%"
              >
              </v-checkbox>
            </v-col>
            <v-col cols="12" md="12">
              <v-textarea
                hide-details
                label="Remarks"
                v-model="payout.remarks"
                dense
                outlined
                style="width:100%"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <custom-file-upload
                :refresh="fileUploadRefresh"
                @setMedias="updateInvoices"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" :disabled="$v.payout.$invalid || loading" text @click="savePayout">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
// import paymentAPIs from './paymentAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import pairingAPIs from '../Pairing/pairingAPIs';
import influencerAPIs from '../Influencer/influencerAPIs'
import config from '@/config';
import { mapState, mapGetters } from 'vuex';
import CustomFileUpload from '../../scoped/custom/CustomFileUpload';
export default {
  mixins: [validationMixin],
  props: {
    value: Boolean
  },
  validations: {
    payout: {
      campaign: {
        required
      },
      handle: {
        required
      },
      bankAccountNo: {
        required
      },
      receivingName: {
        required
      },
      amount: {
        required
      }
    }
  },
  components: {
    CustomFileUpload
  },
  data() {
    return {
      payout: {
        campaign: null,
        handle: null,
        bankAccountNo: null,
        bankSwiftCode: null,
        receivingName: null,
        amount: '',
        chkGST: false,
        remarks: ''
      },
      pickDate: false,
      search: null,
      campaigns: [],
      influencers: [],
      invoiceFiles: [],
      fileUploadRefresh: 1,
      loading: false
    }
  },
  computed: {
    ...mapState({
      paymentStatuses: state => state.payment.status
    }),
    ...mapGetters('payment', [
      'paymentStatusOptions'
    ]),
    selectedCampaignErrors() {
      const errors = [];
      if (!this.$v.payout.campaign.$dirty) return errors;
      !this.$v.payout.campaign.required && errors.push(' This field is required.');
      return errors;
    },
    bankNoErrors() {
      const errors = [];
      if (!this.$v.payout.bankAccountNo.$dirty) return errors;
      !this.$v.payout.bankAccountNo.required && errors.push('This field is required.');
      return errors;
    },
    receivingNameErrors() {
      const errors = [];
      if (!this.$v.payout.receivingName.$dirty) return errors;
      !this.$v.payout.receivingName.required && errors.push('This field is required.');
      return errors;
    },
    handleErrors() {
      const errors = [];
      if (!this.$v.payout.handle.$dirty) return errors;
      !this.$v.payout.handle.required && errors.push('This field is required.');
      return errors;
    },
    amountErrors() {
      const errors = [];
      if (!this.$v.payout.amount.$dirty) return errors;
      !this.$v.payout.amount.required && errors.push('This field is required.');
      return errors;
    },
    campaignStatus() {
      return Object.values(config.campaignStatus).join();
    }
  },
  watch: {
    value: function (newValue) {
      this.payout.campaign = null
      this.resetForm()
    }
  },
  mounted() {
    this.fetchCampaigns();
  },
  methods: {
    close() {
      this.$emit('input');
    },
    async savePayout() {
      try {
        if (!this.invoiceFiles.length) {
          this.$swal({
            text: 'Please Upload Invoice',
            type: 'error'
          });
          return;
        }
        this.loading = true
        const formData = this.constructData(this.payout);
        await campaignAPIs.savePaymentConsolidatedInvoice(formData);
        this.loading = false
        this.$emit('created');
        this.$emit('input');
        this.$swal({
          text: 'New invoice record is created',
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        this.loading = false
        this.$swal({
          text: error.message,
          type: 'error'
        });
      }
    },
    async fetchCampaigns() {
      try {
        const resp = await campaignAPIs.getAllCampaigns(this.campaignStatus, false);
        const data = resp.data;
        const campaigns = data.campaigns;
        this.campaigns = campaigns.map(cmp => {
          return {
            name: cmp.name,
            id: cmp.id,
            assignedTo: cmp.assignedTo,
            clientID: cmp.clientID
          };
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          text: 'Cannot fetch the list of campaigns',
          icon: 'error'
        });
      }
    },
    constructData(input) {
      let formData = new FormData();
      let defaultCreateData = Object.assign({}, {
        campaignID: input.campaign.id,
        influencerID: input.handle.influencerID || '',
        handle: input.handle.handle,
        platform: input.handle.platform,
        swift_code: input.bankSwiftCode,
        bank_account: input.bankAccountNo,
        amount: parseInt(input.amount),
        fullName: input.receivingName,
        GST: input.chkGST,
        remarks: input.remarks
      });
      formData.append('data', JSON.stringify(defaultCreateData))
      for (let val of this.invoiceFiles) {
        formData.append('uploadFile', val);
      }
      return formData;
    },
    async changeCampaign() {
      this.resetForm()
      let newValue = this.payout.campaign
      if (newValue && newValue.name) {
        try {
          // get pairing influencers
          const resp = await pairingAPIs.getPairedInfluencersByCampaign(newValue.id)
          this.setInfluencers(resp)
        } catch (error) {
          console.log(error);
          this.$swal({
            text: 'Cannot fetch the list of Influencers',
            icon: 'error'
          });
        }
      }
    },
    setInfluencers(resp) {
      this.influencers = resp.map(pairing => {
        if (pairing.influencer_details) {
          let influencerDetails = pairing.influencer_details
          let payoutDetails = pairing.payout_details
          return Object.assign({}, {
            influencerID: influencerDetails.influencerID || '',
            handle: influencerDetails.instagramHandle,
            platform: influencerDetails.platform || 'instagram',
            amount: payoutDetails.amount || 0
          })
        }
      })
    },
    async changeInfluencer() {
      this.payout.bankSwiftCode = null
      this.payout.bankAccountNo = null
      this.payout.receivingName = null
      if (this.payout.handle.influencerID) {
        try {
          const resp = await influencerAPIs.getInfluencer(this.payout.handle.influencerID)
          this.payout.bankSwiftCode = resp.swiftCode || ''
          this.payout.bankAccountNo = resp.bankAccount || ''
          this.payout.receivingName = resp.fullName || ''
        } catch (error) {
          console.log(error);
          this.$swal({
            text: 'Cannot fetch Influencer Data',
            icon: 'error'
          });
        }
      }
    },
    resetForm() {
      this.payout.bankAccountNo = null
      this.payout.receivingName = null
      this.payout.handle = null
      this.payout.bankSwiftCode = null
      this.influencers = []
      this.invoiceFiles = []
      this.fileUploadRefresh += 1
    },
    updateInvoices(medias) {
      this.invoiceFiles = Object.assign([], medias)
    }
  }
};
</script>



// WEBPACK FOOTER //
// UploadInvoiceModal.vue?b45343f8